import { useQuery } from "@tanstack/react-query";

import { type ProductClient } from "@fitness-app/data-models/entities/ProductClient";

import { supabase } from "~/store/initializeStore";

export const useCustomerProductClients = (customerId: string, enabled = true) => {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["customerProductClients", customerId],
    enabled: enabled && Boolean(customerId),
    queryFn: async ({ signal }) => {
      const builder = supabase
        .from("product_client")
        .select("*")
        .eq("customerId", customerId)
        .order("createdAt", { ascending: false });
      const query = signal ? builder.abortSignal(signal) : builder;
      const { data, error } = await query;

      if (error) {
        throw new Error(error.message);
      }

      return (data ?? []) as unknown as ProductClient[];
    },
  });

  return {
    list: data ?? [],
    isLoading,
    isFetching,
  };
};
